import css from 'styled-jsx/css';

export default css`.login-switch-bar {
    height: 64px;
    &-line {
        padding: 16px 24px 0;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        &:before,
        &:after {
            content: '';
            display: block;
        }
        div {
            height: 22px;
            font-size: 14px;
            font-weight: 400;
            color: #999999;
            line-height: 22px;
            cursor: pointer;
        }
        div.active {
            height: 26px;
            font-size: 16px;
            font-weight: 500;
            color: #000000;
            line-height: 24px;
            position: relative;
        }
        div.active::after {
            content: '';
            position: absolute;
            bottom: 0;
            height: 2px;
            left: 0;
            right: 0;
            background: #FF6400;
            border-radius: 1px;
        }
    }
    &-scan {
        font-size: 16px;
        font-weight: 500;
        color: #000000;
        line-height: 24px;
        padding-top: 26px;
        text-align: center;
    }
}`